import { Grid } from '@backstage/ui';
import { EntityAboutCard, EntityLayout } from '@backstage/plugin-catalog';
import { EntityWarningContent } from './common/EntityWarningContent';
import { HasComponentsGridItem } from './common/HasComponentsGridItem';
import { HasResourcesGridItem } from './common/HasResourcesGridItem';
import { HasApisGridItem } from './common/HasApisGridItem';
import { EntityLinksGridItem } from './common/EntityLinksGridItem';
import { DeploysComponentsGridItem } from './common/DeploysComponentsGridItem';
import { EntityLayoutWrapper } from './common/EntityLayoutWrapper';

export const systemEntity = (
  <EntityLayoutWrapper>
    <EntityLayout.Route path="/" title="Overview">
      <Grid.Root columns="12" gap="4">
        {EntityWarningContent}
        <Grid.Item colSpan={{ initial: '12', md: '6' }}>
          <EntityAboutCard />
        </Grid.Item>
        <EntityLinksGridItem colSpan={{ initial: '12', md: '6' }} />
        <DeploysComponentsGridItem colSpan={{ initial: '12', md: '6' }} />
        <HasComponentsGridItem colSpan={{ initial: '12', md: '6' }} />
        <HasResourcesGridItem colSpan={{ initial: '12', md: '6' }} />
        <HasApisGridItem colSpan={{ initial: '12', md: '6' }} />
      </Grid.Root>
    </EntityLayout.Route>
  </EntityLayoutWrapper>
);
